<template>
  <v-card class="pa-2 mb-4">
    <v-card-title class="text-h6 mt-2 mb-2">
      <h4 class="mb-0">
        <strong>Último Completado</strong>
      </h4>
    </v-card-title>
    <v-card-text>
      <div class="space-y-2">
        <v-row>
          <v-col cols="6">
            <h5 class="font-weight-medium mb-0">
              <strong>#{{ lastCompleted.code }}</strong>
            </h5>

          </v-col>
          <v-col cols="6" class="text-right">
            <v-chip color="success" variant="tonal" size="small">
              <v-icon start size="small">mdi-check-circle</v-icon>
              <strong>Completado</strong>
            </v-chip>

          </v-col>
        </v-row>
        <div class="text-body-2 text-medium-emphasis">
          Cliente: {{ lastCompleted.client.name }}
        </div>
        <div class="text-caption text-medium-emphasis">
          Hora: {{ formatTime(lastCompleted.completedAt) }}
        </div>

        <v-btn color="blue-grey" variant="outlined" size="small" @click="handleReprint" :loading="loading">
          <v-icon start size="small">mdi-printer</v-icon>
          Reimprimir
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "LastCompleted",
  props: {
    lastCompleted: {
      type: Object,
      required: true,
    },
    loading: {
      type: Object,
      required: false
    }
  },
  methods: {
    formatTime(date) {
      if (!date) return "";
      return new Date(date).toLocaleTimeString();
    },
    handleReprint() {
      this.$emit('reprint', this.lastCompleted.code);
    },
  },
};
</script>

<style scoped>
.space-y-2>*+* {
  margin-top: 8px;
}
</style>
